// extracted by mini-css-extract-plugin
module.exports = {"VoteButton":"VoteButton_VoteButton__11pCA"};